import { queryOptions } from "@tanstack/react-query";

import {
  extendedSelectConfig,
  loadExtendedSelect,
} from "@/config/extendedSelectConfig";
import type {
  ExtendedSelectKey,
  ExtendedSelectRowMap,
} from "@/config/extendedSelectRowMap";
import { fetchApiSelectExtended } from "@/hooks/useApiSelect";
import {
  EXTENDED_SELECT_GC_TIME_MS,
  EXTENDED_SELECT_STALE_TIME_MS,
  extendedSelectKeys,
} from "./extendedSelectKeys";

export function extendedSelectQueryOptions<K extends ExtendedSelectKey>(key: K) {
  return queryOptions<ExtendedSelectRowMap[K][]>({
    queryKey: extendedSelectKeys.one(key),
    queryFn: () => loadExtendedSelect(key, fetchApiSelectExtended),
    staleTime: EXTENDED_SELECT_STALE_TIME_MS,
    gcTime: EXTENDED_SELECT_GC_TIME_MS,
    enabled: key in extendedSelectConfig,
  });
}
